import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import AutocompleteInput from './AutocompleteInput';

export default class DropdownTypeahead extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.onListItemSelected = this.onListItemSelected.bind(this);
        this.onKeywordChange = this.onKeywordChange.bind(this);

        this.state = {
            invalidInput: false,
            dropdownOpen: false,
            touched: false,
            keyword: '',
            keywordLoading: false,
            keywordNoResults: false,
            selectedItem: props.selectedItem,
            listItems: props.listItems ? JSON.parse(JSON.stringify(props.listItems)) : null,
            filteredListItems: []
        };
    }

    toggle() {
        const { dropdownOpen, listItems } = this.state;
        this.setState({
            listItems: listItems ? JSON.parse(JSON.stringify(listItems)) : null,
            dropdownOpen: !dropdownOpen,
            touched: true
        }, () => {
            if (!dropdownOpen) {
                const input = document.getElementById("inputId");
                if (input) {
                    input.focus();
                }

            }
        });
    }

    onListItemSelected(index) {
        const selectedItem = this.state.filteredItems[index];
        this.setState({ selectedItem });
        if (this.props.onItemSelected) {
            this.props.onItemSelected(selectedItem);
        }
        this.toggle();
    }

    onKeywordChange(e, value) {
        //const keyword = e.target.value;
        const keyword = value;
        const { listItems, textFieldName } = this.props;
        const { filteredListItems } = this.state;
        this.setState({ filteredListItems: [], keywordLoading: true });
        let filteredItems = null;
        let items = []
        if (keyword.length > 1 && listItems) {
            const allItems = JSON.parse(JSON.stringify(listItems));
            if (allItems && allItems.length > 0) {
                const value = keyword.toLowerCase();
                filteredItems = allItems.filter(item => item[textFieldName].toLowerCase().indexOf(value) > -1);
                items = filteredItems.map((itemList, itemListIndex) => { return { id: itemList.i, label: itemList[textFieldName], index: itemListIndex } });
            }
        }
        this.setState({ keyword, filteredItems, filteredListItems: items, keywordLoading: false, keywordNoResults: (filteredListItems.length === 0 && keyword.length > 2) });
    }

    render() {
        const { className, disabled, name, textFieldName, placeholder, showAsInvalid, listItems } = this.props;
       
        const { ddListItem, selectedItem, keyword, filteredItems, dropdownOpen, invalidInput, touched, keywordLoading, filteredListItems, keywordNoResults } = this.state;
        const oneOption = ddListItem && ddListItem.length === 1;
        const placeholderLabel = placeholder ? placeholder : (!oneOption ? 'Select a ' + name : name);
        const disableDropDown = disabled || oneOption;
        const containerClassName = (className ? className : "") + (selectedItem ? " input-not-empty" : " input-empty") + (touched ? " input-touched" : " input-untouched") + (invalidInput || showAsInvalid ? " input-invalid" : " input-valid");
        const hintText = 'Start typing a ' + name.toLowerCase() + ' name to see results';

        return (
            <div className={`bswh-dropdown-typeahead il-group ${containerClassName}`}>
                <div className="il-label" aria-hidden="true"> {placeholderLabel}</div>
                <Dropdown isOpen={dropdownOpen} toggle={this.toggle}>
                    <DropdownToggle caret={!oneOption} className={!selectedItem ? "li-label" : ""} disabled={disableDropDown}>
                        {selectedItem && <>{selectedItem[textFieldName]}</>}
                    </DropdownToggle>
                    {dropdownOpen &&
                        <>
                        <div className="bswh-dropdown-typeahead__input">
                            <AutocompleteInput value={keyword} loading={keywordLoading}
                                placeholder="" prependIcon="icon-search" autoFocus
                                itemList={filteredListItems} noResults={keywordNoResults} autoHighlight={false}
                                onChange={(e, value) => { this.onKeywordChange(e, value) }}
                                onSelect={(value, item) => this.onListItemSelected(item.index)}
                            />
                        </div>
                        <DropdownItem tag={"div"} className="list-dropdown-item bswh-dropdown-typeahead__hint">{hintText}</DropdownItem>
                        </>
                    }
                    {/*<DropdownMenu>
                        <DropdownItem toggle={false} tag={"div"} className="list-dropdown-item bswh-dropdown-typeahead__input">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="icon-search"></span>
                                </div>
                                <input id="inputId" type="text" className="form-control" value={keyword} onChange={this.onKeywordChange} />
                            </div>
                        </DropdownItem>
                        {filteredItems && filteredItems.length > 0
                            ? filteredItems.map((item, index) => (
                                <DropdownItem key={name + index} onClick={() => this.onListItemSelected(index)} className="list-dropdown-item">
                                    <div className="">
                                        <span className="">{item[textFieldName]}</span>
                                    </div>
                                </DropdownItem>
                            ))
                            : <>
                                <DropdownItem tag={"div"} className="list-dropdown-item bswh-dropdown-typeahead__hint">{hintText}</DropdownItem>
                            </>
                        }
                    </DropdownMenu>*/}
                </Dropdown>
            </div>
        );
    }
}